import useBackWithFallback from "../../../../common/core-ui/useBackWithFallback.ts";
import BaseLinkOrButton from "../../../../common/core-ui/BaseLinkOrButton.tsx";
import { clsx } from "clsx";
import CaretsSmallLeft from "../../../../common/icons/CaretsSmallLeft.tsx";
import { FormattedMessage } from "react-intl";
import { ReactNode } from "react";
import { HeaderTheme } from "./types.ts";

export default function BackButton({
  to,
  theme,
  children,
  className,
}: {
  to: string;
  theme?: HeaderTheme;
  children?: ReactNode;
  className?: string;
}) {
  const goBack = useBackWithFallback(to);

  return (
    <BaseLinkOrButton
      onClick={goBack}
      className={clsx(
        "vst-link",
        "vst-link-option-no-underline",
        "vst-link-option-no-wrap",
        (theme === "accent" || theme === "outline") && "vst-link-variant-white",
        className
      )}
    >
      <CaretsSmallLeft />
      {children ?? <FormattedMessage defaultMessage="Back" />}
    </BaseLinkOrButton>
  );
}
